import React, { HTMLAttributes } from "react";
import * as palette from "@govlaunch/palette";
import { FormattedMessage } from "react-intl";

export default function BetaBadge(props: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      {...props}
      css={{
        background: "#fff",
        color: palette.innovatorBlue,
        fontWeight: "bold",
        fontSize: 12,
        textTransform: "uppercase",
        borderRadius: 4,
        border: `1px solid ${palette.innovatorBlue}`,
        padding: "4px 6px",
        letterSpacing: 0.5,
      }}
    >
      <FormattedMessage defaultMessage="Beta" id="riw/yc" />
    </span>
  );
}
